import { render } from "./OrderTableAdmin.vue?vue&type=template&id=468c6cdc"
import script from "./OrderTableAdmin.vue?vue&type=script&lang=js"
export * from "./OrderTableAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__